"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._clientAPI = exports.configure = exports.forceReRender = exports.getStorybook = exports.clearDecorators = exports.addParameters = exports.addDecorator = exports.setAddon = exports.storiesOf = void 0;

var _clientApi = _interopRequireDefault(require("./client-api"));

require("./channel");

var globalHook = '__DOCZ_PLUGIN_STORYBOOK_CLIENT_API__';
var clientAPI = window[globalHook] || new _clientApi.default();
window[globalHook] = clientAPI; // mock the minimal set of exports from `@storybook/react`

var storiesOf = clientAPI.storiesOf;
exports.storiesOf = storiesOf;
var setAddon = clientAPI.setAddon;
exports.setAddon = setAddon;
var addDecorator = clientAPI.addDecorator;
exports.addDecorator = addDecorator;
var addParameters = clientAPI.addParameters;
exports.addParameters = addParameters;
var clearDecorators = clientAPI.clearDecorators;
exports.clearDecorators = clearDecorators;
var getStorybook = clientAPI.getStorybook;
exports.getStorybook = getStorybook;

var forceReRender = function forceReRender() {}; // TODO: noop


exports.forceReRender = forceReRender;

var configure = function configure(loaders, module) {
  if (loaders) {
    // load all stories into the client API via one or more imperative commonjs
    // 'require' trees
    loaders();
  }
}; // additional, private exports


exports.configure = configure;
var _clientAPI = clientAPI;
exports._clientAPI = _clientAPI;
//# sourceMappingURL=index.js.map